function readMaybeJson(value) {
  if (value == null) return null;
  if (typeof value === 'object') return value;
  try {
    return JSON.parse(String(value));
  } catch {
    return null;
  }
}

function pickFirstNonEmpty(...values) {
  for (const value of values) {
    if (value == null) continue;
    const s = String(value).trim();
    if (s) return s;
  }
  return null;
}

/** Resolve provider display fields from company + logistics provider profiles. */
export function resolveLogisticsProviderDisplayInfo(companyData, logisticsProfileData) {
  const company = companyData && typeof companyData === 'object' ? companyData : {};
  const logistics = logisticsProfileData && typeof logisticsProfileData === 'object' ? logisticsProfileData : {};
  const companyContact =
    readMaybeJson(company.contact_details) || readMaybeJson(company.contactDetails) || {};
  const logisticsContact =
    readMaybeJson(logistics.contact_details) || readMaybeJson(logistics.contactDetails) || {};
  const basicInfo =
    readMaybeJson(logistics.basic_information) || readMaybeJson(logistics.basicInformation) || {};

  const providerName =
    pickFirstNonEmpty(
      company.company_name,
      company.companyName,
      basicInfo.companyName,
      basicInfo.company_name,
    ) || '—';

  const contactNumber =
    pickFirstNonEmpty(
      logisticsContact.primaryPhone,
      logisticsContact.primary_phone,
      logisticsContact.contact_number,
      logisticsContact.contactNumber,
      logisticsContact.phone,
      logisticsContact.mobile,
      logisticsContact.mobile_number,
      companyContact.primaryPhone,
      companyContact.primary_phone,
      companyContact.contact_number,
      companyContact.contactNumber,
      companyContact.phone,
      companyContact.mobile,
      company.user_phone,
      company.userPhone,
    ) || '—';

  const email =
    pickFirstNonEmpty(
      logisticsContact.primaryEmail,
      logisticsContact.primary_email,
      logisticsContact.contact_email,
      logisticsContact.contactEmail,
      logisticsContact.email,
      companyContact.primaryEmail,
      companyContact.primary_email,
      companyContact.contact_email,
      companyContact.contactEmail,
      companyContact.email,
      company.user_email,
      company.userEmail,
    ) || '—';

  return { providerName, contactNumber, email };
}

export async function fetchLogisticsProviderDisplayInfo(commonService) {
  const [companyRes, logisticsRes] = await Promise.all([
    commonService.get('/company/my-profile'),
    commonService.get('/company/logistics/my-profile').catch(() => null),
  ]);
  const companyBody = companyRes?.data ?? companyRes ?? {};
  const companyData = companyBody?.data ?? companyBody;
  const logisticsBody = logisticsRes?.data ?? logisticsRes ?? {};
  const logisticsData = logisticsBody?.data ?? logisticsBody;
  return resolveLogisticsProviderDisplayInfo(companyData, logisticsData);
}
